import * as React from 'react';
import { connect } from 'react-redux';
import { IProductEditState, types } from '@/redux/pages/product-edit';
import store from '@/redux';
import { parse } from 'query-string';

const Toast = require('react-toast-mobile');

class ProductIntroduction extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            text: this.props.desc,
            source: parse(this.props.location.search).source
        }
    }
    public render() {
        return (
            <section className="expert-intro">
                <div className="expert-intro-text" >
                    <textarea placeholder="请输入产品描述..." onChange={() => this.inputAction()} value={this.state.text} readOnly={this.state.source === '4'}></textarea>
                </div>
                {
                    this.state.source !== '4' ?
                    <div className="expert-intro-btns">
                        <button className="btn-submit" onClick={() => this.confirmAction()}>确定</button>
                    </div> : null
                }                
            </section>
        )
    }

    // 输入
    private inputAction() { 
        this.setState({
            text: (event as any).target.value
        });
    }

    // 确定
    private confirmAction() { 
        const text = this.state.text;
        if (text === '') {
            return Toast.T.notify('请输入产品描述');
        } else if (text.length > 4000) {
            return Toast.T.notify('产品描述最多不能超过4000个字');
        } else if (!/[\u4e00-\u9fa5]/img.test(text)) { 
            return Toast.T.notify('产品描述必须有中文');
        }
        store.dispatch({
            type: types.INPUT,
            data: {
                key: 'desc',
                value: text
            }
        });
        this.props.history.goBack();
    }
}

const mapStateToProps = (state: any):IProductEditState => { 
    return {
        ...state.productEditReducers
    }
}

export default connect(mapStateToProps)(ProductIntroduction);